module.exports = __webpack_public_path__ + "static/img/background1.e27e9f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background1.png
// module id = 751
// module chunks = 1